import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { EditUserComponent } from './edit-user/edit-user.component';
import { LocalDataSource } from 'ng2-smart-table';
import { Router } from '@angular/router';
import { User } from '../../shared/data/user';
import { plainToClass } from 'class-transformer';
import swal from 'sweetalert2';
import { ActiveRenderComponent } from './active-render.component';
import { ProfilRenderComponent } from './profil-render.component';

@Component({
  selector: 'ngx-users-list',
  templateUrl: './userslist.component.html',
  styleUrls: ['./userslist.component.scss']
})
export class UsersListComponent implements OnInit {
 
  constructor(private router:Router,private apiService:ApiService,private dialogService: NbDialogService,private sendeurService:EventSendeurService,private toastr:NbToastrService) { }

  ngOnInit() {
    this.getUsers();
    this.sendeurService.user.subscribe(data =>{
      this.getUsers();
    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

  source: LocalDataSource =  new LocalDataSource();
  
   settings = {
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave:false
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      id: {
        title: 'ID',
        type: 'number',
        filter: false,
      },
      prenom: {
        title: 'Nom d\'utilisateur',
        type: 'custom',
        renderComponent: ProfilRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
        filter: false,
      },
     /* username: {
      title: 'Nom de l\'utilisateur',
      type: 'string',
     }, */
     nomComplet: {
      title: "Nom complet",
      type: 'string',
     },
     email: {
      title: 'Email',
      type: 'string',
     },
     adresse: {
      title: 'Adresse',
      type: 'string',
     },
     telephone: {
      title: 'Telephone',
      type: 'number',
     },
     is_active: {
      title: '',
      type: 'custom',
      renderComponent: ActiveRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    },
    
   },
   pager : {
      perPage :10
   },
  
 };


  getUsers(){
    this.apiService.getAllUserProvider().subscribe(data =>{
    
      this.source.load(plainToClass(User, data));
   
    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }


 

 
  select($event){
    this.dialogService.open(EditUserComponent,{context: { id: $event.data.id}});
  }

  /* removeUser($event){
    this.dialogService.open(DeleteUserComponent,{context: { id: $event.data.id, nom:$event.data.nom}});
  }

  createUser(){
    this.dialogService.open(AddUsersComponent);
  } */

  onDelete(event){
    // this.dialogService.open(DeleteProjetConfirmComponent,{context:{id:event.data.id}});
    /* this.articleEdit = event.data;
    this.dialogService.open(DeleteArticleComponent,{context: { id: event.data.id}}); */
    const user = plainToClass( User,  event.data as object);


    this.toastr.warning("Vérifier qu'il ne s'agit pas de l'utilisateur connecté avant de continuer", "oops!");
    /* swal({
      title: 'Suppression utilisateur',
      text: 'Voulez - vous vraiment supprimer ' + user.username + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteUserProvider(user.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        this.toastr.success("Supprimé(e)", user.username);

      }

      // this.dialogIsNotShow = false;


    }); */

  
  }

  onCreate(event){
    this.dialogService.open(EditUserComponent,{context: { id: 0}});
  }


}
